var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonOk',{attrs:{"disabled":_vm.currentStep <= 1},on:{"click":_vm.onClickPrev}},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-menu-left")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }